import { useMemo, useState } from "react";
import { useApolloClient } from "@apollo/client";
import { noop } from "lodash";

import { useAppDispatch, useAppSelector } from "../../../Store";

import Graph_QL, { GqlHook_Returns, StateDataObject } from "..";
import { gqlActions } from "../gqlData_Reducer";
import { filterByConnection } from "../filterByConnection";
import { TestData } from "../../../Assets/TestData/feedCurvesData";
import { FeedCurveTableData } from "../../../Containers/GlobalScreens/FeedCurves/convertSparseMixtureData";

import { PanelBasicQueryInfoInput } from "./GQLCalls/getFeedComponentsCall";
import { FeedCurvesResponse, GET_FEED_CURVES_INFO } from "./GQLCalls/getFeedCurvesCall";
import { FeedCurveItem } from "./FeedDataSlices/feedCurveSlice";
import { CREATE_FEED_CURVE, CreateFeedCurveResponse } from "./GQLCalls/createFeedCurveCall";

interface maintainFeedCurveElements {
  maintainMixture: (optimisticData?: Partial<FeedCurveItem>, updatedMixtureEntries?: Map<number,Partial<FeedCurveTableData>>) => void,
  createFeedCurve: (name: String, specific?: Graph_QL.GQLCons) => Promise<{success: boolean, feedcurve_id: number}>, 
}

export const useFeedCurves = (connection: Graph_QL.GQLCons): GqlHook_Returns<FeedCurveItem, PanelBasicQueryInfoInput> & maintainFeedCurveElements => {
  const dispatch = useAppDispatch();
  const client = useApolloClient();
  const [cursorId, setCursorId] = useState(-1);

  const feedCurvesState = useAppSelector(({graphQlData:{domain}}) => domain.feedCurves);
  const {fullState} = useMemo(() => {
    const state = filterByConnection(feedCurvesState, Graph_QL.ToArr(connection)) as Record<string, FeedCurveItem>
    return Object.entries(state).reduce((accumulator, [key, data]) => {
      if (data.data) {
        const value = {...data.data, domain:key}; 
        accumulator.data = accumulator.data.concat(value)
      }
      return accumulator
    },{fullState: state, data: []} as StateDataObject<FeedCurveItem>)
  },[connection, feedCurvesState]);

  const getFeedCurvesInfo = async (specific?: Graph_QL.GQLCons, input?: PanelBasicQueryInfoInput ) => {
    try {
      await client.query<FeedCurvesResponse>({query: GET_FEED_CURVES_INFO, variables: {...specific?.connection, input}})
      .then((e) => {
        if (e && e.data) {
          dispatch({type: String(gqlActions.domain.feedCurves.maintained), payload: {con: specific?.connection, data: e.data.getPanelFeedCurvesInfo}});
        }
      })
    } catch {
      // TODO CTO: clean up when everything is stable
      dispatch({type: String(gqlActions.domain.feedCurves.maintained), payload: {con: connection?.connection, data: TestData}});
    }
  }
  
  const fetchMore = async (cursor: number|number[], specific?: Graph_QL.GQLCons) => {
    
    }

  const maintainFullFeedCurve = async (changedData?: Partial<FeedCurveItem>) => {
    dispatch({type: String(gqlActions.domain.feedCurves.maintained), payload: changedData})
  }

  const maintainMixture = async (optimisticData?: Partial<FeedCurveItem>, updatedMixtureEntries?:  Map<number,Partial<FeedCurveTableData>>) => {
    dispatch({type: String(gqlActions.domain.feedCurves.maintained), payload: optimisticData})
  }

  const createFeedCurve = async (name: String, specific?: Graph_QL.GQLCons) => {
    const usedConnection = specific ? specific.connection : connection.connection 
    try {
      return await client.mutate<CreateFeedCurveResponse>({mutation: CREATE_FEED_CURVE, variables: {...usedConnection, name}})
        .then((e) => {
          const createdFeedCurve = e.data?.createFeedCurve;
          if (createdFeedCurve && createdFeedCurve.success && createdFeedCurve.updatedValues.length > 0) {
            const createdFeedCurveInfo = createdFeedCurve.updatedValues[0];
            dispatch({type: String(gqlActions.domain.feedCurves.maintained), payload: {con: usedConnection, data: [{...createdFeedCurve, milestones: [], mixture:[]}]}})
            return {feedcurve_id: createdFeedCurveInfo.feedcurve_id, success: true}
          }
          return {success: false, feedcurve_id: -1};
        })
    } catch (error) {
      return {success: false, feedcurve_id: -1};
    }
  }

  return {call: getFeedCurvesInfo, fetchMore, deleteEntries: noop, data: fullState, maintainEntries: maintainFullFeedCurve, maintainMixture, createFeedCurve}
} 

